import { useApi } from '@mainstage/core-plugin-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationApiRef } from '../notificationApiRef';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import {
  WebhookHeaderUpsertRequest,
  WebhookHeaderUpsertResponse,
} from '@agilelab/plugin-wb-notification-common';
import { WEBHOOK_HEADERS } from './reactQuery';

export const useUpsertWebhookHeader = () => {
  const notificationApi = useApi(notificationApiRef);
  const alertApi = useApi(customAlertApiRef);
  const queryClient = useQueryClient();

  return useMutation<
    WebhookHeaderUpsertResponse,
    Error,
    WebhookHeaderUpsertRequest
  >({
    mutationFn: (request: WebhookHeaderUpsertRequest) =>
      notificationApi.upsertWebhookHeader(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [WEBHOOK_HEADERS] });
      alertApi.post({
        severity: 'success',
        message: 'Header saved successfully',
      });
    },
    onError: e => {
      alertApi.post({
        severity: 'error',
        message: e.message,
      });
    },
  });
};
